import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 40 34" {...props}>
      <title>{"Learning"}</title>
      <g stroke="#FEFEFE" fill="none" fillRule="evenodd">
        <path d="M10.187 16.572c0-1.615.576-3.097 1.535-4.252M5.736 18.944a6.641 6.641 0 01-1.938-4.086M4.276 23.75A6.718 6.718 0 010 22.225M6.662 28.176a6.71 6.71 0 01-4.11 1.927M11.496 29.628A6.634 6.634 0 019.96 33.88M15.946 27.255a6.641 6.641 0 011.939 4.087M17.406 22.449c1.624 0 3.114.573 4.276 1.527M15.02 18.024a6.71 6.71 0 014.11-1.928M29.718 4.252A6.634 6.634 0 0028.183 0M34.169 6.624a6.641 6.641 0 001.938-4.086M35.629 11.43a6.718 6.718 0 004.276-1.526M33.243 15.856a6.71 6.71 0 004.11 1.927M28.41 17.308c0 1.615.575 3.096 1.535 4.252M23.959 14.935a6.641 6.641 0 00-1.939 4.087M22.499 10.129a6.718 6.718 0 00-4.276 1.527M24.885 5.704a6.71 6.71 0 00-4.11-1.928" />
      </g>
    </svg>
  )
}

export default SvgComponent
